/* esm.sh - @use-gesture/core@10.3.1 */
export * from "/*@use-gesture/core@10.3.1/esnext/core.mjs";
